//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { KugouMusic } from '@/components/common';
export default {
  name: 'artist-music',
  components: {
    KugouMusic: KugouMusic
  },
  props: {
    title: {
      type: String,
      default: '艺人金曲'
    },
    artistName: String,
    artistAvatar: String,
    musicList: Array
  },
  mounted: function mounted() {
    this.$emit('previewStats');
  },
  methods: {
    goToMusic: function goToMusic(e) {
      console.log('e111', e);
      var url = e.url;
      this.$emit('gotoMusic', {
        url: url
      });
    }
  }
};